import classNames from "classnames";
import Modal from "components/Modal";
import { FC } from "react";

import ModalRemoveCompanyContent from "./Content";
import styles from "./styles.module.scss";

type PropTypes = {
  id?: number;
  isVisible: boolean;
  className?: string;
  name?: string;
  portfolios?: string;
  assets?: string;
  users?: string;
};

const WidgetModalRemoveCompany: FC<PropTypes> = ({ id, isVisible, className, name, portfolios, assets, users }) => {
  return (
    <Modal
      title="Delete Company"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalRemoveCompanyContent id={id} name={name} portfolios={portfolios} assets={assets} users={users} />
    </Modal>
  );
};

export default WidgetModalRemoveCompany;
